import * as React from 'react'
import './PresentationFormStrapiWrapper.scss'

type Props = {
    children: React.ReactNode
}

const PresentationFormStrapiWrapper = ({children}: Props) => {
    return <div className={'strapi-page__presentation-form-wrapper'}>{children}</div>
}

export default PresentationFormStrapiWrapper
